import { ProfileContentProps } from "../../types/Profile";
import FavouritesTab from "./tabs/FavouritesTab";
import RecentTab from "./tabs/RecentTab";
import PotentialTab from "./tabs/PotentialTab";
import AnalyticsTab from "./tabs/AnalyticsTab";

export default function ProfileContent({
  activeTab,
  outfits,
  favouritedOutfits,
  onToggleFavourite,
}: ProfileContentProps) {
  return (
    <div className="mx-auto max-w-7xl px-6 py-8 sm:px-8 lg:px-12">
      {activeTab === "favourites" && <FavouritesTab />}

      {activeTab === "recent" && (
        <RecentTab
          outfits={outfits}
          favouritedOutfits={favouritedOutfits}
          onToggleFavourite={onToggleFavourite}
        />
      )}

      {activeTab === "potential" && (
        <PotentialTab
          outfits={outfits}
          favouritedOutfits={favouritedOutfits}
          onToggleFavourite={onToggleFavourite}
        />
      )}

      {activeTab === "analytics" && <AnalyticsTab />}
    </div>
  );
}
